import { types } from '../types/typesGeneral'
import { fetchConToken } from '../../helpers/fetch'

import { iniChangeItemsName } from '../../redux/actions/pptos'
import { iniChangeItemsNameGastos } from '../../redux/actions/pptosGastos'

import { toast } from 'react-toastify'

export const startGetGeneral = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('general');
            const body = await resp.json();
            if (body.ok) {
                dispatch(generalGetCategories(body.data.categories))
                dispatch(generalGetServices(body.data.services))
                dispatch(generalGetUnidadMedida(body.data.unidadesMedidas))
                dispatch(generalGetUsuariosTarea(body.data.usuariosTarea))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const initGetServices = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/services/all')
            const body = await resp.json()
            if (body.ok) {
                dispatch(generalGetServices(body.data))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const initGetServicesGastos = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/services/all/buy')
            const body = await resp.json()
            if (body.ok) {
                dispatch(generalGetServicesGasto(body.data))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetInfoPropietaria = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('ajustes/info-propietaria');
            const body = await resp.json();
            if (body.ok) {
                dispatch(getInfoPropietaria(body.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniLoadAjustesDetail = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken(`ajustes`)
            const body = await resp.json()

            if (body.ok) {
                dispatch(ajustesLoadDetail(body.data));
            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const startGetGeneralGasto = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('general/gasto');
            const body = await resp.json();
            if (body.ok) {
                dispatch(generalGetCategoriesGasto(body.data.categories));
                dispatch(generalGetServicesGasto(body.data.services));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniAddNewService = (items, newService, item) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/services', newService, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg)

                newService.id = body.data.id || 0
                dispatch(generalAddNewServices(newService))

                const values = {
                    nombre: newService.nombre,
                    id_servicio: newService.id,
                    id_categoria: 0,
                    id_titulo: item.id_titulo,
                }

                dispatch(iniChangeItemsName(items, values, item))

            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniAddNewServiceGastos = (items, newService, item) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/services', newService, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg)

                newService.id = body.data.id || 0
                dispatch(generalAddNewServicesBuy(newService))

                const values = {
                    nombre: newService.nombre,
                    id_servicio: newService.id,
                    id_categoria: 0,
                    id_titulo: item.id_titulo,
                }

                dispatch(iniChangeItemsNameGastos(items, values, item))

            }

        } catch (error) {
            console.log(error)
        }
    }
}

export const iniAddNewCategories = (items, newCategory, item) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/categories', newCategory, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg)

                console.log(body.data)
                newCategory.id = body.data.id || 0
                dispatch(generalAddNewCategories(newCategory))

                const values = {
                    nombre: newCategory.nombre,
                    id_servicio: 0,
                    id_categoria: newCategory.id,
                    id_titulo: 0,
                }

                dispatch(iniChangeItemsName(items, values, item))

            }

        } catch (error) {
            console.log(error);
        }
    }
}

export const iniAddNewCategoriesGastos = (items, newCategory, item) => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('catalog/categories', newCategory, 'POST');
            const body = await resp.json();
            if (body.ok) {
                toast.success(body.msg)

                console.log(body.data)
                newCategory.id = body.data.id || 0
                dispatch(generalAddNewCategoriesBuy(newCategory))

                const values = {
                    nombre: newCategory.nombre,
                    id_servicio: 0,
                    id_categoria: newCategory.id,
                    id_titulo: 0,
                }

                dispatch(iniChangeItemsNameGastos(items, values, item))

            }

        } catch (error) {
            console.log(error);
        }
    }
}

export const iniLoadGeneralBudget = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('general/budgets');
            const body = await resp.json();
            if (body.ok) {

                // console.log('--body.data AHHH--', body.data)

                dispatch(generalGetUnits(body.data.units))
                dispatch(generalGetExecutives(body.data.executives))
                dispatch(generalGetCurrency(body.data.currency))
                dispatch(generalGetFormasPagos(body.data.formasPagos))
                dispatch(generalGetFormasPagosVentas(body.data.formasPagosVentas))
                dispatch(generalGetTiposDocumentos(body.data.tiposDocumentos))
                dispatch(generalGetRules(body.data.rules))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetListaBancos = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('general/bancos');
            const body = await resp.json();
            if (body.ok) {
                dispatch(generalGetListaBancos(body.data.listaBancos))
                dispatch(generalGetListaTiposCuenta(body.data.listaTiposCuenta))
                dispatch(generalGetListaCtasBancarias(body.data.listaCtasBancarias))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const startOpenProgress = (open) => ({
    type: types.generalSetOpenProgress,
    payload: open
})

const generalGetCategories = (categories) => ({
    type: types.generalGetCategories,
    payload: categories
})

const generalGetServices = (services) => ({
    type: types.generalGetServices,
    payload: services
})

const generalGetUnidadMedida = (unidad) => ({
    type: types.generalGetUnidadMedida,
    payload: unidad
})

const generalGetRules = (rules) => ({
    type: types.generalGetRules,
    payload: rules
})

const generalGetCategoriesGasto = (categories) => ({
    type: types.generalGetCategoriesGasto,
    payload: categories
})

const generalGetServicesGasto = (services) => ({
    type: types.generalGetServicesGasto,
    payload: services
})

const generalAddNewServices = (services) => ({
    type: types.generalAddNewServices,
    payload: services
})

const generalAddNewCategories = (category) => ({
    type: types.generalAddNewCategories,
    payload: category
})

const generalAddNewServicesBuy = (services) => ({
    type: types.generalAddNewServicesBuy,
    payload: services
})

const generalAddNewCategoriesBuy = (category) => ({
    type: types.generalAddNewCategoriesBuy,
    payload: category
})

const generalGetUnits = (units) => ({
    type: types.generalGetUnits,
    payload: units
})

const generalGetExecutives = (executives) => ({
    type: types.generalGetExecutives,
    payload: executives
})

const generalGetUsuariosTarea = (users) => ({
    type: types.generalGetUsuariosTarea,
    payload: users
})

const generalGetCurrency = (currency) => ({
    type: types.generalGetCurrency,
    payload: currency
})

// const generalGetCustomers = (customers) => ({
//     type: types.generalGetCustomers,
//     payload: customers
// })

export const generalGetFormasPagos = (formasPagos) => ({
    type: types.generalGetFormasPagos,
    payload: formasPagos
})

export const generalGetFormasPagosVentas = (formasPagos) => ({
    type: types.generalGetFormasPagosVentas,
    payload: formasPagos
})

const generalGetTiposDocumentos = (tiposDocumentos) => ({
    type: types.generalGetTiposDocumentos,
    payload: tiposDocumentos
})

const generalGetListaBancos = (listaBancos) => ({
    type: types.generalGetListaBancos,
    payload: listaBancos
})

const generalGetListaTiposCuenta = (listaTiposCuenta) => ({
    type: types.generalGetListaTiposCuenta,
    payload: listaTiposCuenta
})

const generalGetListaCtasBancarias = (listaCtasBancarias) => ({
    type: types.generalGetListaCtasBancarias,
    payload: listaCtasBancarias
})


// ajustes
const ajustesLoadDetail = (ajustesDetail) => ({
    type: types.ajustesLoadDetail,
    payload: ajustesDetail
})

// info propietaria
const getInfoPropietaria = (data) => ({
    type: types.getInfoPropietaria,
    payload: data
})

